module.exports = __webpack_public_path__ + "static/media/bg.5fee6e78.png";